// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/SFPRODISPLAYREGULAR.OTF", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'SF Pro Display';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}




.Side_bar_side_bar__00HY- {
    min-height: 100vh;
    width: 21%;
    padding: 15px;
    background-color: #105293;
    /* background-color: #40424b; */
    /* font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    font-family: 'SF Pro Display'; */
    font-family: 'Lato', sans-serif;
    font-weight: 600;
}


.Side_bar_theme___DpJBP {
    display: flex;
    min-height: 90vh;
    padding: 0 !important;
}

.Side_bar_theme_sidemenuDesktop__NBOet {
    display: block;
    width: 18%;
    background-color: #105293;
    /* background-color: #40424b; */
}


.Side_bar_tabsInnerDiv__y2v-Y {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    font-size: 14px;
    letter-spacing: 1px;
}

.Side_bar_sidemenu_mobile__IsI0H {
    display: none;

}

.Side_bar_sidebarHeading__\\+Lcqb{
    background-color: whitesmoke !important;
    color: black !important;
    border-radius: 20px;
    
 }


.Side_bar_listItems__Ohpc8 {
    display: flex;
    width: 75%;
    color: white;
    /* border: 1px solid red; */
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    position: relative
}



.Side_bar_listItems__Ohpc8 span {
    font-size: 14px !important;

}

.Side_bar_listItems__Ohpc8 span:nth-child(3) {
    display: inline-block;
    position: absolute;
    right: 5px;
    top: -1px;
    background: #0097ff;
    border-radius: 50%;
    width: 24px;
    height: 21px;
    font-weight: 800;
    text-align: center;
    color: white;
}

.Side_bar_side_bar__00HY->div, .Side_bar_side_bar__00HY->section>div {
    color: #2392FF !important;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 2px;
    text-transform: uppercase;

}

.Side_bar_collapseitemText__DlUmx{
    color: grey !important;
}
.Side_bar_collapseitemText__DlUmx:hover{
    color: #0f73d7 !important ;
}

.Side_bar_sidebar_navbar__5mywY{
    display: none;
}

@media screen and (max-width: 1024px) {
    .Side_bar_side_bar__00HY- {
        width: 25%;
    }
}


@media screen and (max-width: 768px) {

    .Side_bar_icon_color__\\+-2x2{
        color: #0097ff;
    }
    .Side_bar_sidebar_navbar__5mywY{
        display: block;
    }
    .Side_bar_sidemenu_desktop__Cv2Q\\+ {
        display: none;
    }

    .Side_bar_sidemenu_mobile__IsI0H {
        display: block;
    }

    .Side_bar_side_bar__00HY- {
        background-color: white;
        width: 100%;
        min-height: 75vh;
    }

    .Side_bar_theme_sidemenuDesktop__NBOet {
        display: none;
    }

    .Side_bar_theme___DpJBP {
        overflow: scroll;
    }

    .Side_bar_sideBarLogo__5gbvu {
        display: none;
    }

    .Side_bar_side_bar__00HY- li:nth-child(3) {
        /* background-color: red;
        height: 53px; */
    }

    .Side_bar_side_bar__00HY- li:nth-child(3) span {
        font-size: 23px;
        font-weight: 700;
        /* color: #2392FF; */
    }

    .Side_bar_side_bar__00HY- li i {
        color: #2392FF !important;
        font-size: 22px;
    }

    .Side_bar_side_bar__00HY- li span,.Side_bar_side_bar__00HY- section li span {
        color: gray;
        letter-spacing: 1px;
        font-size: 14px;
    }



    .Side_bar_side_bar__00HY->hr {
        background-color: grey;
    }

    .Side_bar_side_bar__00HY- li div>div {
        background-color: #006CD6 !important;
    }

    .Side_bar_collapseitemText__DlUmx {
        color: white !important;
    }

    .Side_bar_listItems__Ohpc8 i {
        font-size: 14px !important;
        animation-name: Side_bar_floatingIcons__7G9ve;
        animation-duration: 0.5s;

    }

    @keyframes Side_bar_floatingIcons__7G9ve {
        0% {
            transform: translate(200px) scale(0);
            opacity: 0;
        }

        100% {
            transform: translate(0px) scale(1);
            opacity: 1;
        }
    }



    .Side_bar_listItems__Ohpc8 {
        width: 95%;
        color: rgba(255, 255, 255, .8);
    }

    /* .listItems ~ i{
        margin-right: 30px;
    } */




}`, "",{"version":3,"sources":["webpack://./src/components/thememaker/sidebar/Side_bar.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,+DAAqE;IACrE,mBAAmB;IACnB,kBAAkB;AACtB;;;;;AAKA;IACI,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,+BAA+B;IAC/B;oCACgC;IAChC,+BAA+B;IAC/B,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,yBAAyB;IACzB,+BAA+B;AACnC;;;AAGA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,uCAAuC;IACvC,uBAAuB;IACvB,mBAAmB;;CAEtB;;;AAGD;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT;AACJ;;;;AAIA;IACI,0BAA0B;;AAE9B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;;AAE7B;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;;AAGA;;IAEI;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI;uBACe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,yBAAyB;QACzB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,eAAe;IACnB;;;;IAIA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,6CAA6B;QAC7B,wBAAwB;;IAE5B;;IAEA;QACI;YACI,oCAAoC;YACpC,UAAU;QACd;;QAEA;YACI,kCAAkC;YAClC,UAAU;QACd;IACJ;;;;IAIA;QACI,UAAU;QACV,8BAA8B;IAClC;;IAEA;;OAEG;;;;;AAKP","sourcesContent":["@font-face {\n    font-family: 'SF Pro Display';\n    src: url('../../../fonts/SFPRODISPLAYREGULAR.OTF') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n\n\n\n.side_bar {\n    min-height: 100vh;\n    width: 21%;\n    padding: 15px;\n    background-color: #105293;\n    /* background-color: #40424b; */\n    /* font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;\n    font-family: 'SF Pro Display'; */\n    font-family: 'Lato', sans-serif;\n    font-weight: 600;\n}\n\n\n.theme_ {\n    display: flex;\n    min-height: 90vh;\n    padding: 0 !important;\n}\n\n.theme_sidemenuDesktop {\n    display: block;\n    width: 18%;\n    background-color: #105293;\n    /* background-color: #40424b; */\n}\n\n\n.tabsInnerDiv {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    font-size: 14px;\n    letter-spacing: 1px;\n}\n\n.sidemenu_mobile {\n    display: none;\n\n}\n\n.sidebarHeading{\n    background-color: whitesmoke !important;\n    color: black !important;\n    border-radius: 20px;\n    \n }\n\n\n.listItems {\n    display: flex;\n    width: 75%;\n    color: white;\n    /* border: 1px solid red; */\n    justify-content: flex-start;\n    align-items: center;\n    gap: 20px;\n    position: relative\n}\n\n\n\n.listItems span {\n    font-size: 14px !important;\n\n}\n\n.listItems span:nth-child(3) {\n    display: inline-block;\n    position: absolute;\n    right: 5px;\n    top: -1px;\n    background: #0097ff;\n    border-radius: 50%;\n    width: 24px;\n    height: 21px;\n    font-weight: 800;\n    text-align: center;\n    color: white;\n}\n\n.side_bar>div, .side_bar>section>div {\n    color: #2392FF !important;\n    font-weight: 600;\n    font-size: 12px;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n\n}\n\n.collapseitemText{\n    color: grey !important;\n}\n.collapseitemText:hover{\n    color: #0f73d7 !important ;\n}\n\n.sidebar_navbar{\n    display: none;\n}\n\n@media screen and (max-width: 1024px) {\n    .side_bar {\n        width: 25%;\n    }\n}\n\n\n@media screen and (max-width: 768px) {\n\n    .icon_color{\n        color: #0097ff;\n    }\n    .sidebar_navbar{\n        display: block;\n    }\n    .sidemenu_desktop {\n        display: none;\n    }\n\n    .sidemenu_mobile {\n        display: block;\n    }\n\n    .side_bar {\n        background-color: white;\n        width: 100%;\n        min-height: 75vh;\n    }\n\n    .theme_sidemenuDesktop {\n        display: none;\n    }\n\n    .theme_ {\n        overflow: scroll;\n    }\n\n    .sideBarLogo {\n        display: none;\n    }\n\n    .side_bar li:nth-child(3) {\n        /* background-color: red;\n        height: 53px; */\n    }\n\n    .side_bar li:nth-child(3) span {\n        font-size: 23px;\n        font-weight: 700;\n        /* color: #2392FF; */\n    }\n\n    .side_bar li i {\n        color: #2392FF !important;\n        font-size: 22px;\n    }\n\n    .side_bar li span,.side_bar section li span {\n        color: gray;\n        letter-spacing: 1px;\n        font-size: 14px;\n    }\n\n\n\n    .side_bar>hr {\n        background-color: grey;\n    }\n\n    .side_bar li div>div {\n        background-color: #006CD6 !important;\n    }\n\n    .collapseitemText {\n        color: white !important;\n    }\n\n    .listItems i {\n        font-size: 14px !important;\n        animation-name: floatingIcons;\n        animation-duration: 0.5s;\n\n    }\n\n    @keyframes floatingIcons {\n        0% {\n            transform: translate(200px) scale(0);\n            opacity: 0;\n        }\n\n        100% {\n            transform: translate(0px) scale(1);\n            opacity: 1;\n        }\n    }\n\n\n\n    .listItems {\n        width: 95%;\n        color: rgba(255, 255, 255, .8);\n    }\n\n    /* .listItems ~ i{\n        margin-right: 30px;\n    } */\n\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"side_bar": `Side_bar_side_bar__00HY-`,
	"theme_": `Side_bar_theme___DpJBP`,
	"theme_sidemenuDesktop": `Side_bar_theme_sidemenuDesktop__NBOet`,
	"tabsInnerDiv": `Side_bar_tabsInnerDiv__y2v-Y`,
	"sidemenu_mobile": `Side_bar_sidemenu_mobile__IsI0H`,
	"sidebarHeading": `Side_bar_sidebarHeading__+Lcqb`,
	"listItems": `Side_bar_listItems__Ohpc8`,
	"collapseitemText": `Side_bar_collapseitemText__DlUmx`,
	"sidebar_navbar": `Side_bar_sidebar_navbar__5mywY`,
	"icon_color": `Side_bar_icon_color__+-2x2`,
	"sidemenu_desktop": `Side_bar_sidemenu_desktop__Cv2Q+`,
	"sideBarLogo": `Side_bar_sideBarLogo__5gbvu`,
	"floatingIcons": `Side_bar_floatingIcons__7G9ve`
};
export default ___CSS_LOADER_EXPORT___;
